export default {
    type: 'event-types',
    aliases: {
        camel: 'eventTypes',
        singular: 'Event type',
        plural: 'Event types',
        lowerSingular: 'event type',
        lowerPlural: 'event types',
    },
    publishable: false,
    adminSection: 'administration',
    componentType: 'lookup',
    components: {},
};
